import { Sidebar, Content } from './HeaderSidebar.styled'

export type HeaderSidebarProps = {
  fill?: boolean
}

const HeaderSidebar: React.FC<HeaderSidebarProps> = ({ children, fill }) => {
  return (
    <Sidebar isFill={fill} data-test='HeaderSidebar'>
      <Content>{children}</Content>
    </Sidebar>
  )
}

export default HeaderSidebar
